module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    attrs: {
      "label": "Reporting Increments",
      "items": _vm.items,
      "item-text": "text",
      "item-value": "value"
    },
    on: {
      "change": _vm.updatePeriod
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
},staticRenderFns: []}